import { render } from "./BanksCreating.vue?vue&type=template&id=18fd47a4&ts=true"
import script from "./BanksCreating.vue?vue&type=script&lang=ts"
export * from "./BanksCreating.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__